export class TextR {

  constructor(
    public id?: number,
    public serverId?: string,
    public value?: string,
    public text?: string,
    public value2?: string,
  ) {  }

}